/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { Image } from '../model';
// @ts-ignore
import { NewVehicleImage } from '../model';
// @ts-ignore
import { VehicleImage } from '../model';
/**
 * VehicleImageApiVehicleImagesCountGet - axios parameter creator
 * 
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function VehicleImageApiVehicleImagesCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/vehicle-images/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * VehicleImageApiVehicleImagesGet - axios parameter creator
 * 
 * @summary 
 * @param {string} [origin] 
 * @param {string} [destination] 
 * @param {string} [corporation] 
 * @param {string} [vehicle] 
 * @param {string} [type] 
 * @param {string} [vehicleCode] 
 * @param {string} [corporationCode] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function VehicleImageApiVehicleImagesGetAxiosParamCreator (origin?: string, destination?: string, corporation?: string, vehicle?: string, type?: string, vehicleCode?: string, corporationCode?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/vehicle-images`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (origin !== undefined) {
        localVarQueryParameter['origin'] = origin;
    }

    if (destination !== undefined) {
        localVarQueryParameter['destination'] = destination;
    }

    if (corporation !== undefined) {
        localVarQueryParameter['corporation'] = corporation;
    }

    if (vehicle !== undefined) {
        localVarQueryParameter['vehicle'] = vehicle;
    }

    if (type !== undefined) {
        localVarQueryParameter['type'] = type;
    }

    if (vehicleCode !== undefined) {
        localVarQueryParameter['vehicleCode'] = vehicleCode;
    }

    if (corporationCode !== undefined) {
        localVarQueryParameter['corporationCode'] = corporationCode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * VehicleImageApiVehicleImagesIdDelete - axios parameter creator
 * Delete a record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function VehicleImageApiVehicleImagesIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('vehicleImagesIdDelete', 'id', id)
    const localVarPath = `/vehicle-images/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * VehicleImageApiVehicleImagesIdGet - axios parameter creator
 * 
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function VehicleImageApiVehicleImagesIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('vehicleImagesIdGet', 'id', id)
    const localVarPath = `/vehicle-images/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * VehicleImageApiVehicleImagesIdPut - axios parameter creator
 * Update a record
 * @summary 
 * @param {string} id 
 * @param {NewVehicleImage} newVehicleImage 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function VehicleImageApiVehicleImagesIdPutAxiosParamCreator (id: string, newVehicleImage: NewVehicleImage, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('vehicleImagesIdPut', 'id', id)
    // verify required parameter 'newVehicleImage' is not null or undefined
    assertParamExists('vehicleImagesIdPut', 'newVehicleImage', newVehicleImage)
    const localVarPath = `/vehicle-images/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newVehicleImage, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * VehicleImageApiVehicleImagesPost - axios parameter creator
 * Create a new record
 * @summary 
 * @param {NewVehicleImage} newVehicleImage 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function VehicleImageApiVehicleImagesPostAxiosParamCreator (newVehicleImage: NewVehicleImage, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newVehicleImage' is not null or undefined
    assertParamExists('vehicleImagesPost', 'newVehicleImage', newVehicleImage)
    const localVarPath = `/vehicle-images`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newVehicleImage, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for vehicleImagesGet operation in VehicleImageApi.
 * @export
 * @interface VehicleImageApiVehicleImagesGetRequest
 */
export interface VehicleImageApiVehicleImagesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesGet
     */
    readonly origin?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesGet
     */
    readonly destination?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesGet
     */
    readonly corporation?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesGet
     */
    readonly vehicle?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesGet
     */
    readonly type?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesGet
     */
    readonly vehicleCode?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesGet
     */
    readonly corporationCode?: string
}

/**
 * Request parameters for vehicleImagesIdDelete operation in VehicleImageApi.
 * @export
 * @interface VehicleImageApiVehicleImagesIdDeleteRequest
 */
export interface VehicleImageApiVehicleImagesIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for vehicleImagesIdGet operation in VehicleImageApi.
 * @export
 * @interface VehicleImageApiVehicleImagesIdGetRequest
 */
export interface VehicleImageApiVehicleImagesIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for vehicleImagesIdPut operation in VehicleImageApi.
 * @export
 * @interface VehicleImageApiVehicleImagesIdPutRequest
 */
export interface VehicleImageApiVehicleImagesIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleImageApiVehicleImagesIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewVehicleImage}
     * @memberof VehicleImageApiVehicleImagesIdPut
     */
    readonly newVehicleImage: NewVehicleImage
}

/**
 * Request parameters for vehicleImagesPost operation in VehicleImageApi.
 * @export
 * @interface VehicleImageApiVehicleImagesPostRequest
 */
export interface VehicleImageApiVehicleImagesPostRequest {
    /**
     * 
     * @type {NewVehicleImage}
     * @memberof VehicleImageApiVehicleImagesPost
     */
    readonly newVehicleImage: NewVehicleImage
}

/**
* 
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function VehicleImageApiVehicleImagesCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await VehicleImageApiVehicleImagesCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {VehicleImageApiVehicleImagesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function VehicleImageApiVehicleImagesGet(requestParameters: VehicleImageApiVehicleImagesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await VehicleImageApiVehicleImagesGetAxiosParamCreator(requestParameters.origin, requestParameters.destination, requestParameters.corporation, requestParameters.vehicle, requestParameters.type, requestParameters.vehicleCode, requestParameters.corporationCode, options, configuration);
    const request: () => AxiosPromise<Array<Image>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a record
* @summary 
* @param {VehicleImageApiVehicleImagesIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function VehicleImageApiVehicleImagesIdDelete(requestParameters: VehicleImageApiVehicleImagesIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await VehicleImageApiVehicleImagesIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {VehicleImageApiVehicleImagesIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function VehicleImageApiVehicleImagesIdGet(requestParameters: VehicleImageApiVehicleImagesIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await VehicleImageApiVehicleImagesIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<VehicleImage> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a record
* @summary 
* @param {VehicleImageApiVehicleImagesIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function VehicleImageApiVehicleImagesIdPut(requestParameters: VehicleImageApiVehicleImagesIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await VehicleImageApiVehicleImagesIdPutAxiosParamCreator(requestParameters.id, requestParameters.newVehicleImage, options, configuration);
    const request: () => AxiosPromise<VehicleImage> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new record
* @summary 
* @param {VehicleImageApiVehicleImagesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function VehicleImageApiVehicleImagesPost(requestParameters: VehicleImageApiVehicleImagesPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await VehicleImageApiVehicleImagesPostAxiosParamCreator(requestParameters.newVehicleImage, options, configuration);
    const request: () => AxiosPromise<VehicleImage> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
